module.exports = __webpack_public_path__ + "static/media/power-switch.35dcd9cf.svg";